const prefix = 'importHistoricalWork/';

export const ACTION_TYPES = {
  toggleIsPartNumberOnlySearch: `${prefix}TOGGLE_IS_PART_NUMBER_ONLY_SEARCH`,
  toggleIsRootPartOnlySearch: `${prefix}TOGGLE_IS_ROOT_PART_ONLY_SEARCH`,
} as const;
